module.exports = __webpack_public_path__ + "img/zk_logo.e0724964.jpg";